import React from 'react';
import { AppContextProvider } from './model/context/AppContextProvider'
import { ConnectionProvider } from './connection/ConnectionProvider'
import { ThemeContextProvider } from './theme/ThemeContextProvider'
import { NotificationProvider } from './notifications/NotificationProvider'
export const AppRoot = ({ children, use_default_theme, connection_info, load_db_adapter }) => {
    return (
        <NotificationProvider>
            <ConnectionProvider connection_info={connection_info} load_db_adapter={load_db_adapter}>
                <AppContextProvider>
                    <ThemeContextProvider use_default_theme={use_default_theme}>
                        {children}
                    </ThemeContextProvider>
                </AppContextProvider>
            </ConnectionProvider>
        </NotificationProvider>
    )
}

